<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
    name: 'BaseIcon',
    props: {
        width: {
            type: [Number, String],
            default: 24
        },
        height: {
            type: [Number, String],
            default: 24
        },
        viewBox: {
            type: String,
            default: '0 0 24 24'
        }
    }
};
</script>

<style scoped></style>
